import {
    useMutation, UseMutationOptions, UseMutationResult, useQueryClient,
} from '@tanstack/react-query';
import { generatePath, useNavigate } from 'react-router-dom';
import { FORCED_RANKING_SEARCH } from 'src/lib/routes';
import { deleteForcedRankingStrategy } from 'src/mutations/deleteForcedRankingStrategy';
import { QUERY_KEY } from 'src/queries/queryForcedRankingStrategies';

type RankingStrategy = Models.IngestConfigApi.ForcedRankings.ForcedRankingStrategy;
type QueryKey = App.ForcedRankings.QueryKey;

export const useDeleteForcedRankingStrategy = (
    options?: Omit<UseMutationOptions<RankingStrategy, Error, RankingStrategy, QueryKey>, 'mutationFn'>,
): UseMutationResult<void, Error, App.ForcedRankings.DeleteMutationVariables> => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation(
        deleteForcedRankingStrategy,
        {
            onSuccess: () => {
                queryClient.cancelQueries([QUERY_KEY]);
                queryClient.invalidateQueries([QUERY_KEY]);
                navigate(generatePath(FORCED_RANKING_SEARCH), {
                    state: { deleted: true },
                });
            },
            useErrorBoundary: options?.useErrorBoundary ?? true,
        },
    );
};
